<p-card>
  <p-table [value]="catalogProjects" *ngIf="catalogProjects !== undefined && catalogProjects !== null">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Available</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-project let-ri="rowIndex">
      <tr>
        <td>
          <div class="flex w-full">{{ project.project.name }}</div>
          <div *ngIf="project.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
        </td>
        <td>
          <p-toggleswitch
            [(ngModel)]="project.isAvailable"
            attr.data-testid="toggle{{ project.id }}"
            (change)="updateCatalogProject(project)"
            [disabled]="project.isActive == false" />
        </td>
        <td style="width: 15rem">
          <app-audit-info [value]="project.project" [direction]="'vertical'"></app-audit-info>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
